<template>
<div>
<v-flex v-if="this.$vuetify.breakpoint.xs | this.$vuetify.breakpoint.sm">
<v-btn flat color="#00bd95" style="text-decoration:none"
        v-if="exibetoolbarcell"
        @click.stop="drawer = !drawer"          
        icon
        dark
    >
    <v-icon>
        menu
    </v-icon>
    </v-btn>
<v-navigation-drawer      
      v-model="drawer"
      absolute
      temporary
      left
      app
      fixed
      transition="fade-transition"
      dark    
    >

      <v-list class="pa-4">
        <v-list-tile tag="div">               
            <img src="../assets/logo.png" alt="Odontobase" width="160px">                    
        </v-list-tile>
      </v-list>

      <v-list class="pt-0" dense>
        <v-divider dark></v-divider>

        <!-- <v-list-tile
        to='/' active-class="cyan darken-3" avatar
        >
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
            <v-list-tile-title>Home</v-list-tile-title>
        </v-list-tile> -->

        <!-- <v-list-tile active-class="cyan darken-3" avatar
        to='/servidor-publico'
        >
          <v-list-tile-action>
            <v-icon>account_balance</v-icon>
          </v-list-tile-action>
            <v-list-tile-title>Servidor Público</v-list-tile-title>
        </v-list-tile> -->

        <!-- <v-list-tile active-class="cyan darken-3" avatar
        to='/pessoa-fisica'
        >
          <v-list-tile-action>
            <v-icon>person</v-icon>
          </v-list-tile-action>
            <v-list-tile-title>Pessoa Física</v-list-tile-title>
        </v-list-tile> -->

<!--         <v-list-tile active-class="cyan darken-3" avatar
        to='/servidor-publico'
        >
          <v-list-tile-action>
            <v-icon>account_balance</v-icon>
          </v-list-tile-action>
            <v-list-tile-title>Servidor Público</v-list-tile-title>
        </v-list-tile> -->

        <!-- <v-list-tile active-class="cyan darken-3" avatar
        to='/pessoa-juridica'
        >
          <v-list-tile-action>
            <v-icon>domain</v-icon>
          </v-list-tile-action>          
            <v-list-tile-title>Pessoa Jurídica</v-list-tile-title>          
        </v-list-tile> -->

        <!-- <v-list-tile active-class="cyan darken-3" avatar
        to='/pessoajuridica'
        >
          <v-list-tile-action>
            <v-icon>domain</v-icon>
          </v-list-tile-action>          
            <v-list-tile-title>Pessoa Jurídica</v-list-tile-title>          
        </v-list-tile> -->

        <!-- <v-list-tile active-class="cyan darken-3" avatar
        to='/contato'
        >
          <v-list-tile-action>
            <v-icon>email</v-icon>
          </v-list-tile-action>          
            <v-list-tile-title>Contato</v-list-tile-title>          
        </v-list-tile> -->

        <v-list-tile active-class="cyan darken-3" avatar
        to='/areacliente'
        >
          <v-list-tile-action>
            <v-icon>account_box</v-icon>
          </v-list-tile-action>          
            <v-list-tile-title>Área do Cliente</v-list-tile-title>          
        </v-list-tile>

        <!-- <v-list-tile active-class="cyan darken-3" avatar
        to='/faq'
        >
          <v-list-tile-action>
            <v-icon >textsms</v-icon>
          </v-list-tile-action>          
            <v-list-tile-title>FAQ</v-list-tile-title>          
        </v-list-tile> -->        

      </v-list>
    </v-navigation-drawer>
</v-flex>
<v-flex  v-else>
<header class="main-header page-intern" v-if="exibetoolbar">
    <div class="center">
    <router-link to="/" class="main-logo">
        <img src="../assets/logo.png" alt="Odontobase" max-height="100px;">
    </router-link>
    <i class="fas fa-bars open-menu"></i>
    <div class="mask-menu-mobile"></div>
    <br>
    <br>
    <ul class="main-nav">
        <!-- <li>
            <a href="https://www.odontobase.com.br/">Home</a>
        </li> -->
        <!-- <li>
            Planos Odontológicos <i class="fas fa-angle-down"></i>
            <div class="submenu">
                <router-link to="/pessoa-fisica">Pessoa Física</router-link>
                <router-link to="/pessoa-juridica">Pessoa Jurídica</router-link>
            </div>
        </li> -->
        <!-- <li>
            <a href="https://www.odontobase.com.br/FaleConosco">Contato</a>
        </li> -->
        <li>
            <router-link to="/areacliente" >Área do Cliente</router-link>
        </li>
        <li v-if="userloggedin">
            <a @click="Sair" >Sair</a>
        </li>
    </ul>
</div>
</header>  
</v-flex>
<Snackbar ref=chamaSnackbar /> 
</div> 
</template>

<script>
import Snackbar from '../components/snackbar.vue'
import { mapState } from 'vuex'
export default {
     components: {Snackbar},
  data(){
        return{
            drawer: null,
            clipped: true,
            mini: false

        }
    },
    computed: {
       ...mapState({
        userloggedin: state => state.userloggedin,
        exibetoolbar: state => state.isToolbarVisible,
        exibetoolbarcell: state => state.isToolbarVisibleCell
    }),
    imageHeight() {
    switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '220px'
        case 'sm': return '400px'
        case 'md': return '500px'
        case 'lg': return '600px'
        case 'xl': return '800px'
      }
      return true
    }
    },
    mounted : function(){
      this.$store.dispatch('ExibeToolbar')
    },
    methods: {
    Sair(){
            this.$store.dispatch('Sair')
            this.$router.push({ path: '/areacliente' })
        },
    exibeMsgConstrucao(){
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1","Disponível em breve!","INFORMAÇÃO")
        }
    }
}
</script>

<style>
    .buttom{
        text-transform: none;
        font-size: 1.1rem;
        font-weight: 390;
    }
    .v-btn:before {
        opacity: 0;
    }
    .main-header.page-intern .center .main-logo img {
    max-height: 100px;
    }   
</style>
